export const INCREASE = "shoppingcart/increase";
export const DECREASE = "shoppingcart/decrease";
